import { render, staticRenderFns } from "./ModalEdit.vue?vue&type=template&id=b8ca803a&scoped=true"
import script from "./ModalEdit.vue?vue&type=script&lang=js"
export * from "./ModalEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalEdit.vue?vue&type=style&index=0&id=b8ca803a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ca803a",
  null
  
)

export default component.exports